import { render, staticRenderFns } from "./record_wait_rate_box.vue?vue&type=template&id=366e5d5f&scoped=true"
import script from "./record_wait_rate_box.vue?vue&type=script&lang=js"
export * from "./record_wait_rate_box.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/todo-feedback.scss?vue&type=style&index=0&id=366e5d5f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e5d5f",
  null
  
)

export default component.exports